module.exports = __webpack_public_path__ + "img/ai-read.6a5ef91f.png";